module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Carousel', {
    attrs: {
      "images": _vm.activity.images.data
    }
  }), _vm._v(" "), (_vm.activity.base_price) ? _c('div', {
    staticClass: "basePrice"
  }, [_vm._v(_vm._s(_vm.t('from')) + " " + _vm._s(_vm.activity.base_price) + " € "), (_vm.activity.is_priced_per_occurrence) ? _c('span', [_vm._v("/ " + _vm._s(_vm.t('group')))]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-084a79a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-084a79a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/ActivityImages.vue
// module id = 757
// module chunks = 3